import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-continue-watching',
  templateUrl: './continue-watching.component.html',
  styleUrls: ['./continue-watching.component.css']
})
export class ContinueWatchingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
